if (!customElements.get('lamorini-banner')) {
  customElements.define('lamorini-banner', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.track = this.querySelector('[data-banner-track]');
      this.slides = [...this.querySelectorAll('[data-banner-slide]')];
      this.dots = [...this.querySelectorAll('[data-banner-dot]')];
      this.index = 0; this.paused = false; this.hovering = false;
      if (!this.track || !this.slides.length) return;
      const controls = this.querySelector('[data-banner-controls]');
      if (controls) controls.hidden = false;
      this.querySelector('[data-banner-next]')?.addEventListener('click', () => this.go(this.index + 1), options);
      this.querySelector('[data-banner-previous]')?.addEventListener('click', () => this.go(this.index - 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
      this.querySelector('[data-banner-pause]')?.addEventListener('click', () => {
        this.paused = !this.paused; this.updatePause(); this.schedule();
      }, options);
      this.addEventListener('keydown', event => {
        if (!event.target.closest('[data-banner-controls]')) return;
        if (!['ArrowLeft','ArrowRight'].includes(event.key) || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
        event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('scroll', () => {
        const index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
        if (index !== this.index) {this.index = index; this.update(false);}
      }, options);
      this.track.addEventListener('pointerdown', event => {this.start = {x:event.clientX,y:event.clientY};}, options);
      this.track.addEventListener('pointerup', event => {
        if (!this.start) return;
        const dx = event.clientX - this.start.x, dy = event.clientY - this.start.y;
        this.start = null;
        if (Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)) this.go(this.index + (dx<0 ? 1 : -1));
      }, options);
      this.track.addEventListener('pointercancel', () => {this.start = null;}, options);
      this.addEventListener('mouseenter', () => {this.hovering=true; this.schedule();}, options);
      this.addEventListener('mouseleave', () => {this.hovering=false; this.schedule();}, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index>=0) {this.paused=true; this.go(index); this.updatePause();}
      }, options);
      this.resize = new ResizeObserver(() => this.align()); this.resize.observe(this.track);
      this.update(false); this.schedule();
    }
    disconnectedCallback() {clearTimeout(this.timer); this.abort?.abort(); this.resize?.disconnect();}
    go(index) {this.index=(index+this.slides.length)%this.slides.length; this.align(); this.update(true); this.schedule();}
    align() {this.track.scrollLeft=this.index*this.track.clientWidth;}
    update(announce) {
      this.slides.forEach((slide,index) => {slide.setAttribute('aria-hidden',String(index!==this.index)); slide.inert=index!==this.index;});
      this.dots.forEach((dot,index) => dot.setAttribute('aria-pressed',String(index===this.index)));
      if (announce) this.querySelector('[data-banner-status]').textContent=`Slide ${this.index+1} de ${this.slides.length}`;
    }
    updatePause() {
      const button=this.querySelector('[data-banner-pause]');
      if(button){button.textContent=this.paused?'▶':'Ⅱ';button.setAttribute('aria-label',this.paused?'Retomar rotação':'Pausar rotação');}
    }
    schedule() {
      clearTimeout(this.timer);
      if(this.dataset.autoplay!=='true'||this.slides.length<2||this.paused||this.hovering||this.contains(document.activeElement)||document.hidden||matchMedia('(prefers-reduced-motion: reduce)').matches||window.Shopify?.designMode)return;
      this.timer=setTimeout(()=>this.go(this.index+1),Math.max(4,Number(this.dataset.interval)||6)*1000);
    }
  });
}
